<template>
  <form @submit.prevent="submit">
    <slot />
  </form>
</template>

<script>
import form  from '@/js/util/form.js'

export default {
  inject: { form },
  data() {
    return {
      response: undefined,
    };
  },
  created() {
    this.form.$emit('state', 'resting')
  },
  methods: {
    async submit({ target }) {
      const init = {}

      Array.from(target.elements).forEach(({ name, value }) => {
        if (name === '') {
          return
        }

        Object.assign(init, { [name]: value })
      })

      this.form.$emit('state', 'pending')

      try {
        this.response = await fetch('/wp-admin/admin-ajax.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
          },
          body: 'action=contact&' + new URLSearchParams(init).toString(),
        })
      } catch (exception) {
        this.form.$emit('state', 'rejected')

        return;
      }

      this.form.$emit('state', 'fulfilled')
    },
  },
};
</script>
